import { ReactNode } from 'react'
import { AlertDialog, Button, Flex } from '@radix-ui/themes'

type DeleteConfirmationDialogProps = {
  open: boolean
  title: string
  description: ReactNode
  isDeleting: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteConfirmationDialog = ({
  open,
  title,
  description,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteConfirmationDialogProps) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialog.Content>
        <AlertDialog.Title>{title}</AlertDialog.Title>
        <AlertDialog.Description>{description}</AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="outline">Cancel</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button color="red" onClick={onConfirm} disabled={isDeleting}>
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
